import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from "recharts";
import { Button } from "react-bootstrap";
import { React, useCallback } from "react";
import FileSaver from "file-saver";
import { useCurrentPng } from "recharts-to-png";

const DualAxesChartComparison = ( { allData } ) => {

  // data pre process
  const [ urls, data ] = allData;
  // only show the first 11 url data
  const urlsUpToEleven = urls.slice(0, 11);
  const myDataset = data.image.slice(0, 11);
  // the colors to indicate the urls
  const lineColors = [
  '#8884d8', '#a6ffc7', '#ffc658', '#542600', '#ff85c0',
  '#0088FE', '#03a688', '#8f6300', '#ff6c25', '#CC99FF',
  '#e20000'
  ];
  const [getPngTraffic, { ref: refTraffic, isLoading: isLoadingTraffic }] = useCurrentPng();
  const [getPngPage, { ref: refPage, isLoading: isLoadingPage }] = useCurrentPng();

  const handleDownloadTraffic = useCallback(async () => {
    const png = await getPngTraffic();
    // Verify that png is not undefined
    if (png) {
      // Download with FileSaver
      FileSaver.saveAs(png, 'traffic_comparison.png');
    }
  }, [getPngTraffic]);

  const handleDownloadPage = useCallback(async () => {
    const png = await getPngPage();
    // Verify that png is not undefined
    if (png) {
      // Download with FileSaver
      FileSaver.saveAs(png, 'page_comparison.png');
    }
  }, [getPngPage]);

  const chartWidth = 621;
  const chartHeight = 235;
  let lastDate = "N/A";
  // 获取每个数据数组的最后一个元素,
  const lastDataPoints = myDataset.map((dataArray, index) => {
    // 检查子数组是否为空
    if (dataArray && dataArray.length > 0) {
      const lastDataPoint = dataArray[dataArray.length - 1];
      if (lastDataPoint.date !== null) {
        lastDate = lastDataPoint.date;
      }
      return lastDataPoint;
    } else {
      return null;
    }
  });

  // Define a custom YAxis label formatting function
  const formatYAxisValue = (value) => {
    if (value >= 1000000) {
      return `${value / 1000000}M`;
    } else if (value >= 1000) {
      return `${value / 1000}k`;
    } else {
      return value;
    }
  };

  // Define a custom Tooltip Content formatting function
  const CustomTooltipContent = ( {dataType} ) => (
  <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)', padding: '8px', borderRadius: '4px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
    <p style={{ margin: 0, marginTop: "-2px", fontWeight: 'bold', fontSize: "14px" }}> Date: {lastDate}</p>
    {lastDataPoints.map((dataPoint, index) => (
      <div key={index}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ width: '9px', height: '9px', borderRadius: '50%', marginRight: '5px', marginTop: "3px", backgroundColor: lineColors[index] }}></div>
          <p style={{ margin: 0, marginTop: "-2px", fontSize: "13px" }}>{urlsUpToEleven[index]}: {dataPoint !== null && dataPoint[dataType] !== null ? dataPoint[dataType] : 0}</p>
        </div>
      </div>
    ))}
  </div>
  );

  // If the data is a string, it represents non target JSON data
  if (typeof allData.image === "string") {
    return <strong>Loading...</strong>;
  }

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column' }}>

        {/* draw line chart for Organic Traffic and Organic Pages and arrange them vertically */}
        {[
          { key: 'OrganicTraffic', name: 'Organic Traffic', ref: refTraffic, isLoading: isLoadingTraffic, handleDownload: handleDownloadTraffic },
          { key: 'OrganicPages', name: 'Organic Pages', ref: refPage, isLoading: isLoadingPage, handleDownload: handleDownloadPage }
        ].map((config, i) => (
          <div>
            <h4 style={{ marginBottom: "0", marginTop: "0" }}>{config.name}</h4>
            <LineChart key={i} width={chartWidth} height={chartHeight} ref={config.ref}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" allowDuplicatedCategory={false}/>
              <YAxis dataKey={config.key} domain={['auto', 'auto']} tickFormatter={formatYAxisValue} />

              {/* draw a line for each url */}
              {myDataset.map((lineData, index) => {
                return lineData[config.key] !== null ?(
                < Line key = {index} type = "monotone" dataKey = {config.key} data = {lineData} stroke = {lineColors[index]} dot = {false} activeDot = {{r: 8}} name = {urls[index]}/>
                ) : null;
              })}
              <Tooltip
                active={true}
                cursor={true}
                content={<CustomTooltipContent dataType={config.key} />}
                position={{ x: chartWidth/2, y: 0 }}
                contentStyleObject={{ background: '#fff', border: '1px solid #ccc', borderRadius: '5px' }}
                labelStyleObject={{ color: '#333', marginBottom: '5px' }}
              />
            </LineChart>
            <Button onClick={config.handleDownload}>
              {config.isLoading ? 'Downloading...' : 'Download Chart'}
            </Button>
          </div>
        ))}
      </div>
    </>
  );
};

export default DualAxesChartComparison;
